module.exports = __webpack_public_path__ + "static/datascreenshot-3989aa52b89c049530bbe9b75289b95b.png";